import router from '@/router'

/**
 * Clears authentication-related data from localStorage and resets the application state.
 */
export function clearAuth() {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('access_token_expires')
  router.push('/login')
}

/**
 * Saves access token, refresh token, and their expiry time to localStorage.
 * @param token - The new access token.
 * @param refreshToken - The new refresh token.
 * @param expiresIn - Token expiry time in seconds.
 */
export function saveAccessToken(token: string, refreshToken: string, expiresIn: number) {
  localStorage.setItem('access_token', token)
  localStorage.setItem('refresh_token', refreshToken)
  localStorage.setItem('access_token_expires', (Date.now() + expiresIn * 1000).toString())
}

/**
 * Checks if the access token is empty, or expired
 * @returns True if the access token is expired (or empty), false otherwise.
 */
export function isAccessTokenExpired() {
  const accessToken = tryGetAccessToken()
  const expires = localStorage.getItem('access_token_expires')
  if (!expires || !accessToken) {
    return true
  }
  return Date.now() > parseInt(expires)
}

/**
 * Gets the access token from localStorage. If the token is not present, returns null.
 * @returns The access token.
 */
export function tryGetAccessToken() {
  return localStorage.getItem('access_token')
}
